/** A titled box with help text - every editor section sits in one. */
export const Panel = ({ title, help, children, testId }) => (
  <section data-testid={testId} className="rounded-xl border border-border bg-white">
    <header className="border-b border-border bg-[color:var(--tt-surface-2)] px-4 py-3">
      <h4 className="text-sm font-bold text-foreground">{title}</h4>
      {help ? (
        <p className="mt-1 max-w-3xl text-xs leading-relaxed text-muted-foreground">{help}</p>
      ) : null}
    </header>
    <div className="p-4">{children}</div>
  </section>
);
